/* Opens the new Shopify Inbox widget (<shopify-chat>, July 2026 agent shell)
   from the theme's own contact buttons. Replaces the retired #ShopifyChat
   integration in theme.layout.min.js, which is left in place and no-ops.
   The native chat bubble is hidden via shopify-chat::part(activator) CSS
   in the layout files; the widget itself must stay enabled (app embed)
   for the chat window to exist. */
(function () {
  'use strict';

  var TRIGGER_SELECTOR =
    '[data-type="open-shopify-chat"], [data-type="navigation--open-shopify-chat"]';

  function findActivator() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    // Pre-hydration: placeholder bubble lives directly in the host's shadow root.
    var activator = host.shadowRoot.querySelector('[part~="activator"]');
    if (activator) return activator;
    // Post-hydration: the runtime replaces the placeholder and holds the activator.
    var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
    if (runtime && runtime.shadowRoot) {
      return runtime.shadowRoot.querySelector('[part~="activator"]');
    }
    return null;
  }

  function openChat() {
    var host = document.querySelector('shopify-chat');
    if (!host) return false;
    if (host.hasAttribute('open')) return true;
    var activator = findActivator();
    if (activator) {
      activator.click();
      return true;
    }
    // Fallback if Shopify restructures the shadow DOM again.
    host.setAttribute('open', '');
    return true;
  }

  function closeContainingSidebar(trigger) {
    var wrapper = trigger.closest('.sidebar--wrapper');
    if (!wrapper) return;
    var closeButton = wrapper.querySelector('button[data-type="close-sidebar"]');
    if (closeButton) closeButton.click();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    if (openChat()) closeContainingSidebar(trigger);
  });
})();
